import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataModelSchema } from '../models/data-model.model';

@Injectable({ providedIn: 'root' })
export class DataModelService {
  private readonly http = inject(HttpClient);

  private readonly SCHEMA_MAP: Record<string, string> = {
    'order_confirmation': 'order-confirmation',
    'delivery_note': 'delivery-note',
    'invoice': 'invoice',
    'supply_shortage_report': 'supply-shortage-report',
    'critical_medication_report': 'critical-medication-report',
    'bestellbestätigung': 'order-confirmation',
    'bestellbestaetigung': 'order-confirmation',
    'lieferschein': 'delivery-note',
    'rechnung': 'invoice',
    'xrechnung': 'invoice',
    'engpassmeldung': 'supply-shortage-report',
    'lieferengpassmeldung': 'supply-shortage-report',
    'kritische_medikamente': 'critical-medication-report',
  };

  private resolve(type: string | undefined): string | undefined {
    if (!type) return undefined;
    return this.SCHEMA_MAP[type.trim().toLowerCase()];
  }

  hasSchema(type: string | undefined): boolean {
    return !!this.resolve(type);
  }

  getSchema(type: string): Observable<DataModelSchema | null> {
    const fileName = this.resolve(type);
    if (!fileName) return of(null);
    return this.http.get<DataModelSchema>(`assets/schemas/${fileName}.schema.json`).pipe(
      map(schema => (schema?.root || schema?.variants?.length) ? schema : null)
    );
  }
}
